module.exports = __webpack_public_path__ + "img/filigrana-background.9b37b865.png";